export interface Category {
  id: string;
  name: string;
  desc: string;
  icon: string;
  color: 'primary' | 'accent' | 'secondary';
}

export const categories: Category[] = [
  {
    id: 'entertainment',
    name: '娱乐瓜田',
    desc: '综艺、偶像、剧组的网传说法，逐条核对通告与公开行程',
    icon: 'ri-movie-2-line',
    color: 'primary',
  },
  {
    id: 'business',
    name: '商业传闻',
    desc: '品牌联名、融资并购、经营变动的传言核实',
    icon: 'ri-store-3-line',
    color: 'accent',
  },
  {
    id: 'tech',
    name: '科技爆料',
    desc: '原型机、版本更新、模型评测等提前流出的信息求证',
    icon: 'ri-cpu-line',
    color: 'secondary',
  },
  {
    id: 'society',
    name: '社会热点',
    desc: '政策截图、通知文件、突发事件传言的来源追溯',
    icon: 'ri-government-line',
    color: 'accent',
  },
  {
    id: 'consumer',
    name: '生活消费',
    desc: '成分、成本、价格与营销话术的理性拆解',
    icon: 'ri-shopping-bag-3-line',
    color: 'primary',
  },
  {
    id: 'sports',
    name: '体坛风云',
    desc: '转会、伤情、赛事结果的爆料核实与时间线还原',
    icon: 'ri-football-line',
    color: 'secondary',
  },
];

export const categoryMap: Record<string, Category> = categories.reduce(
  (acc, item) => {
    acc[item.id] = item;
    return acc;
  },
  {} as Record<string, Category>,
);